
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Slider from "react-slick";
import { Link } from 'react-router-dom'; // Ensure Link is imported for routing
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../BabyCare/BabyCare.scss';
import sliderImage1 from '../../img/bg m.png';


const MotherCare  = () => {
  const [expandedSection, setExpandedSection] = useState(null);

  const toggleSection = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
  };

  const [sliderSettings, setSliderSettings] = useState({
    dots: true,
    infinite: false, // Prevent repeating
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "ease-in-out",
    fade: false,
    arrows: true,
    adaptiveHeight: true,
    pauseOnHover: true,
  });
  const detailsVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};
const formVariants = {
  hidden: { opacity: 0, x: -100 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.8 } },
};


  return (
    <div className="patient-care-container">
      {/* Slider Section */}
      <Slider {...sliderSettings} className="header-slider">
        <div className="slider-item">
        <img src={sliderImage1.replace('.','')} alt="SLider" />
          <div className="slider-content">
            {/* <h2> New Born Baby & Mother Care Service </h2> */}
           <p>
                      <Link to="/">HOME</Link> / <Link to="/Services">OUR SERVICES</Link> 
                      </p>
          </div>
        </div>
      
      </Slider>

      
            <div className="content-wrapper">
              <aside className="services-menu">
                <h3>
                  <i className="icon"></i> OUR SERVICES
                </h3>
                <div className="menu-item">
                  <div className="menu-header" onClick={() => toggleSection('patient-care')}>
                  Baby Sitter + Japa Services
                    <span>{expandedSection === 'patient-care' ? '-' : '+'}</span>
                  </div>
                  {expandedSection === 'patient-care' && (
                    <ul>
                      <li><Link to="/Services/HomePatientCare">Home Patient Care</Link></li>
                      <li><Link to="/Services/male">Male/Female Care Givers for Patients</Link></li>
                      <li><Link to="/Services/attendants">Nursing Attendants for Hospitals Or Home</Link></li>
                    </ul>
                  )}
                </div>
                <div className="menu-item">
                  <div className="menu-header" onClick={() => toggleSection('nursing-care')}>
                    Nursing Care
                    <span>{expandedSection === 'nursing-care' ? '-' : '+'}</span>
                  </div>
                  {expandedSection === 'nursing-care' && (
                    <ul>
                      <li><Link to="/Services/male">Male/Female Nurses</Link></li>
                      <li><Link to="/Services/tracheostomy">Tracheostomy Care Nurses</Link></li>
                      <li><Link to="/Services/critical">Critical Care Nurse</Link></li>
                      <li><Link to="/Services/gastrostomy">Gastrostomy Care</Link></li>
                      <li><Link to="/Services/colostomy">Colostomy Care</Link></li>
                      <li><Link to="/Services/ileostomy">Ileostomy Care</Link></li>
                    </ul>
                  )}
                </div>
                <div className="menu-item">
                  <div className="menu-header" onClick={() => toggleSection('baby-care')}>
                    Baby Care
                    <span>{expandedSection === 'baby-care' ? '-' : '+'}</span>
                  </div>
                  {/* {expandedSection === 'baby-care' && (
                    <ul>
                      <li><Link to="/baby-sitter-japa-services">Baby Care</Link></li>
                      <li><Link to="/new-born-care">New Born Baby Care Service</Link></li>
                    </ul>
                  )} */}
                </div>
                <div className="menu-item">
                  <div className="menu-header"> <Link to="/Services/Senior"> Old and Senior Citizens Caretaker Services </Link></div>
                </div>
                <div className="menu-item">
                  <div className="menu-header"> <Link to="/Services/Dementia"> Dementia / Alzheimer's Care Givers </Link> </div>
                </div>
              </aside>
      
        <main className="services-content">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
          >
            <div className="service-details">
              <h1> Mother Care Service</h1>
              <p>
              It will be a great feel which can't be explained is to be a mother. 
              Care Health Nursing have committed employees and well trained one with them to provide 
              prenatal and postnatal nursing service for a new mother who needs a care for first few days 
              about their food, medications who need a support to handle a baby for few days. 
              Also we provide pediatrics nurses and assistant nurses for baby care premature baby care and 
              under-fives.


              </p>
            </div>
          </motion.div>
        </main>
      </div>
      <motion.div
                className="row"
                initial="hidden"
                animate="visible"
                exit="hidden"
            >
                {/* Left Side: Contact Form */}
                <motion.div id="left" variants={formVariants}>
                    <h1>Contact Us</h1>
                    <div className="formbox">
                        <form>
                            <input name="name" type="text" className="short" placeholder="Name" />
                            <input name="email" type="email" className="short" placeholder="Email" />
                            <input name="phone" type="tel" className="short" placeholder="Phone" />
                            <input name="subject" type="text" className="feedback-input" placeholder="Subject" />
                            <textarea name="text" className="feedback-input" placeholder="Message"></textarea>
                            <motion.input
                                type="submit"
                                value="SEND"
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                className="submit-button"
                            />
                        </form>
                    </div>
                </motion.div>

                {/* Right Side: Contact Details */}
                <motion.div id="right" variants={detailsVariants}>
                    <div id="map-overlap">
                        <h2>Head Office Address</h2>
                        <p>
                            1/21 Gali No.1, Lalita Park, <br />
                            Laxmi Nagar, Delhi: 110092
                        </p>
                        <p>
                            <strong>Email:</strong> CareHealthNurses@gmail.com<br />
                            <strong>Phone:</strong> +91-9999790231 / +91-9999407473
                        </p>
                        <p>Providing reliable nursing services with care and compassion.</p>
                    </div>
                    <div id="map" style={{ height: "300px", marginTop: "20px" }}></div>
                </motion.div>
            </motion.div>
    </div>
  );
};
export default MotherCare;





